//getUserWoAssTask
import _axios from '../../../util/axios/AxiosConfig'

export function getDetail(key){
    return _axios({
        url: `/api/Checkout/getDetail?supplyId=${key}`,
        method: 'get'
    })
}

export function submit(data){
    return _axios({
        url: `/api/Checkout/submit`,
        method: 'post',
        data:data
    })
}
